<template>
  <div class="searchProductName">
    <v-autocomplete
      v-model="inputValue"
      item-text="label"
      item-value="value"
      :items="createCustomerSelectBoxValueFrom(productList)"
      dense
      outlined
      return-object
      class="original-selectbox"
      hide-details
      :placeholder="$t('common.common_product-name-perfect-matching')"
      clearable
      :height="height"
      :disabled="disabled"
      :filled="disabled"
      :menu-props="{ closeOnContentClick: false }"
      :no-data-text="$t('common.common_no-data')"
      @input="searchInput = null"
      :search-input.sync="searchInput"
    >
      <template v-slot:selection="{ index }">
        <div v-if="index === 0" class="selectedItem">
          {{ inputValue }}
        </div>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { langConfig } from '@/config'

export default {
  props: {
    value: {
      type: String,
      require: false,
      default: () => ''
    },
    height: {
      type: String,
      require: false,
      default: '32px'
    },
    disabled: { default: false }
  },
  data: () => ({
    searchInput: null,
    productList: []
  }),
  created() {
    this.init()
  },
  methods: {
    ...mapActions('Product', ['getProductListFromApi']),
    ...mapGetters('Product', ['getProductListFromState']),
    init() {
      this.getProductList()
    },
    async getProductList() {
      await this.getProductListFromApi()
      this.productList = this.getProductListFromState()
    },
    createCustomerSelectBoxValueFrom(productList) {
      if (productList) {
        return productList.map((ele) => {
          return this.$i18n.locale == langConfig.LANG_JA
            ? ele.nameJp
            : ele.nameCn
        })
      }
      return []
    }
  },
  computed: {
    inputValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.selectCustomerStyle {
  width: 100%;
  &::v-deep {
    .v-select__selections {
      display: flex; // 追加
      flex-wrap: nowrap; // 追加
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .selectedItem {
      // flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      // & + input {
      //   flex: 0;
      //   &:focus {
      //     flex: 1;
      //   }
      // }
    }
  }
}
</style>
